import { render } from "./UnlockUGC.vue?vue&type=template&id=3471384f"
import script from "./UnlockUGC.vue?vue&type=script&lang=js"
export * from "./UnlockUGC.vue?vue&type=script&lang=js"

import "./UnlockUGC.vue?vue&type=style&index=0&id=3471384f&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__